// Import React
import React from "react";

// Import css
import "./OpenStoreButton.css";

// Import the shared Store URL builders
import { GetStoreUrl, GetMarketplaceUrl } from "global/utilities/StoreURLs";



// Reusable open store button
export default function OpenStoreButton({ alias, path = "", marketplace = false, buttonTitle = "View Store", disabled = false}) {



    // This handles opening the store in a new tab
    const handleOpenStore = (event) => {

        // Stop if there is no Store alias
        if (!marketplace && !alias) {
            return;
        }

        // Build the appropriate Store or Marketplace URL
        const storeUrl = marketplace ? GetMarketplaceUrl(path) : GetStoreUrl(alias, path);

        // Open the store safely in a new tab
        window.open(storeUrl, "_blank", "noopener,noreferrer");

    };



    // Return the button
    return (

        <button
            type="button"
            className={`open-store-button ${!marketplace && !alias ? "open-store-button--disabled" : ""}`}
            onClick={(event) => {
                event.stopPropagation();
                 handleOpenStore(event)}
            } 
            disabled={(!marketplace && !alias) || disabled}
            title={marketplace || alias ? buttonTitle : "No store link available"}
        >

            {/* Small storefront style icon */}
            <span className="open-store-button__icon" aria-hidden="true">

                <svg
                    viewBox="0 0 24 24"
                    className="open-store-button__svg"
                >
                    <path
                        d="M4 10L5.5 5H18.5L20 10"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5 10H19V19H5V10Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9 19V14H15V19"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M3.5 10H20.5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                    />
                </svg>

            </span>

            {/* Button text */}
            <span className="open-store-button__text">
                {buttonTitle}
            </span>

        </button>

    );

}